import { Injectable } from '@angular/core';
import {Staff} from "../model/staff";

const STAFF_KEY = "STAFF"
export const AUTH_ACCESS_TOKEN_KEY = "AUTH_ACCESS_TOKEN"
export const AUTH_REFRESH_TOKEN_KEY = "AUTH_REFRESH_TOKEN"

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  getUser(): Staff | null {
    const user = localStorage.getItem(STAFF_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return null;
  }

  setUser(staff: Staff) {
    localStorage.setItem(STAFF_KEY, JSON.stringify(staff))
  }

  clean() {
    localStorage.removeItem(STAFF_KEY);
    localStorage.removeItem(AUTH_ACCESS_TOKEN_KEY);
    localStorage.removeItem(AUTH_REFRESH_TOKEN_KEY);
  }
}
